import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import formatAppointment from '@/v2/components/forms/Appointment/toForm'
import { baseURL } from '@/v2/constants/requests'

export const useLoadData = appointmentId => {
  const {
    data: clinicData,
    isLoading: loadingClinic,
    error: errorClinic,
  } = useQuery({
    queryKey: ['Clinic'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/clinics.json`)
      if (!res.ok) {
        throw new Error(`Error fetching clinic: ${res.statusText}`)
      }
      return res.json()
    },
  })

  const {
    data: appointmentData,
    isLoading: loadingAppointment,
    isError: errorAppointment,
  } = useQuery({
    queryKey: ['Appointment', `${appointmentId}`],
    queryFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/appointments/${appointmentId}`
      )
      if (!res.ok) {
        throw new Error("We couldn't find the appointment")
      }
      const result = await res.json()
      return result
    },
    enabled: !!appointmentId,
  })

  const loading = loadingClinic || loadingAppointment
  const error = errorClinic || errorAppointment
  const clinic = clinicData
  const types = clinic?.appointmentTypes || {}
  const rooms = clinic?.rooms || []
  const doctors = clinic?.doctors || []
  const appointment = appointmentData || {}
  const patient = appointment.patient

  return useMemo(
    () => ({
      loading,
      error,
      types,
      rooms,
      doctors,
      // appointmentData, not appointment: while the query is in flight there
      // is no appointment, and toForm only returns null for a falsy one.
      appointment: formatAppointment(appointmentData),
      patient,
    }),
    [loading, error, types, rooms, doctors, appointment, patient]
  )
}
